/* @flow */
import React from 'react';
import MediaObject from 'components/MediaObject.jsx';
import Image from 'components/Image.jsx';
import Text from 'components/Text.jsx';
import cx from 'classnames';

import './styles/EducationMediaObject.scss';

export default class EducationMediaObject extends React.Component {
  static propTypes = {
    image: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
    text: React.PropTypes.string.isRequired,
  }

  render() {
    const { image, title, text } = this.props;
    return (
      <MediaObject className={cx('EducationMediaObject', this.props.className)}>
        <div className="EducationMediaObject-imagecol">
          <Image src={image} />
        </div>
        <div>
          <Text element="h3" weight="semibold" className="EducationMediaObject-title">
            {title}
          </Text>
          <Text element="p" color="thunder" size="xsmall">
            {text}
          </Text>
        </div>
      </MediaObject>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/EducationMediaObject.jsx